import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators,UntypedFormBuilder } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { AtributosService } from '../../../services/atributos.service';
import {Subscription} from 'rxjs'
import { CompanySideBarTreeViewService } from '../../../services/company-side-bar-tree-view.service';

@Component({
    selector: 'app-valores-actuales',
    templateUrl: './valores-actuales.component.html',
    styleUrls: ['./valores-actuales.component.scss'],
    standalone: false
})
export class ValoresActualesComponent implements OnInit {

  public addValoresActualesForm: UntypedFormGroup;
  EmpresaId;
  clickEventSubscriptionFromTreeNode:Subscription;
  constructor(
    public _dialogRef: MatDialogRef<ValoresActualesComponent>,
    private _atributosService: AtributosService,
    private _sharedService: SharedService,
    private _formBuilder: UntypedFormBuilder,
    public _companySideBarTreeViewService : CompanySideBarTreeViewService,
    @Inject(MAT_DIALOG_DATA) public data: any

    ) { 

    }

  ngOnInit(): void {
    this.EmpresaId=this.data.empresaid;
    if(this.data.isinsert)
    {
      //Insert Valores Form Builder
        this.addValoresActualesForm =new UntypedFormGroup( {
        id: new UntypedFormControl(0),
        atributoId: new UntypedFormControl(0),
        empresaId: new UntypedFormControl(''),
        tipo: new UntypedFormControl( ''),
        texto: new UntypedFormControl('',Validators.required ),
      } );
    }
    else
    {
      //Update Valores Form Builder
       this.addValoresActualesForm = this._formBuilder.group({
        id: new UntypedFormControl(this.data.element.id),
        atributoId: new UntypedFormControl(this.data.element.atributoId),
        empresaId: new UntypedFormControl(this.data.element.empresaId),
        tipo: new UntypedFormControl(''),
        texto: new UntypedFormControl(this.data.element.texto,Validators.required),
     });
    }
  }

  cancel() {
    this._dialogRef.close();
  }
  saveValoresActuales(){
    this.addValoresActualesForm.patchValue({
      empresaId:this.EmpresaId,
      tipo:this.data.tipo
    });
    this.addValoresActualesForm.markAllAsTouched();
    this.addValoresActualesForm.updateValueAndValidity();
    if (this.addValoresActualesForm.valid) 
    {
      if(this.addValoresActualesForm.get('id').value==0)
      {
        this.AddValoresActuales();
      }
      else
      {
        this.UpdateAddValoresActuales();
      }
    }else
    {
      console.log( this.addValoresActualesForm.value );
    }
  }
  //Add Valores Actuales
  private AddValoresActuales() {
    this._atributosService.AddValoresActuales(this.addValoresActualesForm.value)
      .subscribe(res => {
        if (res.code === 0 ) {
          //this._sharedService.ShowSnackBar('Valores actuales saved', 'Okay', 2000);
          this.cancel();
        } else {
          //this._sharedService.ShowSnackBar('Error saving Valores actuales', 'Okay', 2000);
        }
      }, err => {
        console.log(err)
        this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);      
      });
  }
  //Update ConvenioAtributo
  private UpdateAddValoresActuales() {
    this._atributosService.UpdateValoresActuales(this.addValoresActualesForm.value)
      .subscribe(res => {
        if (res.code === 0 ) {
          //this._sharedService.ShowSnackBar('Valores actuales updated', 'Okay', 2000);
          this.cancel();
        } else {
          //this._sharedService.ShowSnackBar('Error updating Valores actuales', 'Okay', 2000);
        }
      }, err => {
        console.log(err)
        this._sharedService.ShowSnackBar('Api request failed', 'Okay', 2000);      
      });
  }

}
